import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEW_WATCH_TOKEN_SHOW_ERROR':
      return action.error;

    case 'ONEWAYINTERVIEW_WATCH_TOKEN_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEW_WATCH_TOKEN_SHOW_LOADING':
      return action.loading;

    case 'ONEWAYINTERVIEW_WATCH_TOKEN_SHOW_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEW_WATCH_TOKEN_SHOW_SUCCESS':
      return action.retrieved;

    case 'ONEWAYINTERVIEW_WATCH_TOKEN_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function eventSource(state = null, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEW_WATCH_TOKEN_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved, eventSource });
